export default {
  homePage: '主页',
  chatPage: '聊天',
  contactUs: '联系我们',
  submitRequest: '提交请求',
  question: '问题',
  subject: '主题',
  description: '描述',
  email: '您的电子邮件',
  attach: '最多可附加4个文件。文件大小必须小于10 MB。',
  delete: '删除',
  sizeExceeded: '文件大小必须小于10 MB。',
  numberExceeded: '最多可附加4个文件。',
  wrongFormat: '附件必须是以下类型的文件：.jpg、.jpeg、.png、.bmp、.tif、.tiff、.gif、.webp、.avi、.mp4、.mov、.flv、.mkv、.webm、.txt、.csv。',
  send: '发送',
  messageSent: '您的消息已成功发送。我们的客服团队审核完您的请求后，我们会通过您提供的电子邮件地址与您取得联系。',
  formUnavailable: '工单创建表单当前不可用。您可以通过帮助中心提交工单。',
  helpCenter: '转到帮助中心。',
  issueEmpty: '请选择问题类型。',
  subjEmpty: '请输入您的咨询主题。',
  descEmpty: '请输入您的问题。',
  emailInvalid: '请输入您的电子邮件地址。请确保电子邮件输入正确。',
  // Issue types
  type: '选择问题类型',
  gameQuestion: '游戏问题',
  techIssue: '技术问题',
  paymIssue: '支付问题',
  gameplayIssues: '游戏玩法问题',
  feedback: '反馈和建议',
  dpo: '隐私保护请求/DPO联系人',
  // GDPR form
  gdprCheckbox: `我已阅读并理解以上条件。`,
  gdprType: '选择删除原因（可选）',
  gdprRestart: '我想开始新游戏',
  gdprBored: `我不喜欢这款游戏`,
  gpdrMultiacc: `我还有其他账户，不需要这个账户`,
  gdprExpectations: `这款游戏不符合我的期待`,
  gdprDataSafety: `我不想共享我的个人数据`,
  gdprPrices: '游戏太贵了',
  gdprOther: '其他',
  gdprCreate: `<p>您可以在此处请求完全删除您的账户及所有相关数据。如果您只想删除特定服务器上的游戏档案，请在游戏主屏幕上点击齿轮图标，向下滚动，然后点击“支持”选项旁边的“打开”。在聊天中，进入“账户与隐私”→“删除账户”→“删除服务器上的个人资料”。</p>
<p>如果您选择删除数据，您将失去所有的游戏进度、得分和成就。<strong>您在所有服务器上的进度都将被永久删除。它也将会从我们的服务器中删除</strong>。</p>
<p我们严格按照法律要求保护您的数据并尊重您的权利。为了确保您能够顺利访问该项目，我们收集的数据是必不可少的。如果您在我们完成数据删除请求后运行该项目，您将需要再次接受我们的 <a href="https://www.nexters.com/hwa/tos_zh_cn/">条款</a>和<a href="https://www.nexters.com/hwa/privacy_zh_cn/">隐私政策</a>。在这种情况下，我们可能会再次开始收集您的数据。在您的请求完成之前，您可以访问您的进度和成就，而无需额外接受我们的 <a href="https://www.nexters.com/hwa/tos_zh_cn/">条款</a>和<a href="https://www.nexters.com/hwa/privacy_zh_cn/">隐私政策</a>。</p>
<p>如果您确认此请求，我们将在确认日期后的 30 天内完成。此外，请注意，这段时间是最长时限。因此，我们可能会按照内部请求处理程序提前完成请求。在提出删除个人数据的请求时，请务必谨慎：这一过程一旦执行，将无法撤销。</p>
此外，如果您改变主意，您有 14 天的时间可以撤回您的请求。要取消请求：
<ol><li>点击主游戏屏幕右上角的齿轮图标，向下滚动，然后点击“删除我的账号以及我在游戏服务器上的所有数据”选项旁边的“打开”。您将会看到“取消”按钮。点击该按钮以取消请求。</li>
<li>或者，您可以使用我们的聊天机器人取消您的请求。点击主游戏屏幕右上角的齿轮图标，向下滚动，然后点击“支持”选项旁边的“打开”按钮。在聊天中，请前往“账户与隐私”→“删除账户”→“删除《勇士争霸》账户”→“取消账户删除请求”。</li></ol>
<p>如果您同意上述条件并想继续，请按确认。</p>
`,
  confirm: '确认',
  gdprConfirmed1: '您的删除请求已受理。自以下请求创建之日起 30 天内，您在所有服务器上取得的全部进度都将被永久删除 —',
  gdprConfirmed2: `<p>您可以在 14 天内取消此请求。要执行此操作：
<ol><li>点击主游戏屏幕右上角的齿轮图标，向下滚动，然后点击“删除我的账号以及我在游戏服务器上的所有数据”选项旁边的“打开”。您将会看到“取消”按钮。点击该按钮以取消请求。</li>
<li>或者，您可以使用我们的聊天机器人取消您的请求。点击主游戏屏幕右上角的齿轮图标，向下滚动，然后点击“支持”选项旁边的“打开”按钮。在聊天中，请前往“账户与隐私”→“删除账户”→“删除《勇士争霸》账户”→“取消账户删除请求”。</li></ol></p>
<p>您还将在第 7 天和第 14 天通过游戏内邮件收到提醒。<strong>请注意，14 天后您将无法撤销账户删除请求。</strong></p>`,
  gdprCancel: `<p>如果您想取消您的账户删除请求，请点击“取消账户删除请求”按钮。</p>`,
  gdprCancelConfirmed: `<p>我们严格按照法律规定，为您的数据提供适当级别的保护，并尊重您的权利。</p>
  <p><strong>根据您的要求，我们已撤销您的删除请求，您的进度将不会被删除。</strong></p>
  <p>请注意，我们将会继续收集数据。</p>`,
  gdprCancelButton: `取消账户删除请求`,
  // Meya 
  digestEmpty: '欢迎！如果您有任何与游戏相关的问题，我们的支持团队将很乐意为您提供帮助！',
  loadingChat: '正在加载聊天…',
  loadingChatStart: `如果没有显示聊天按钮，请`,
  loadingChatLink: `点击此处  `,
  loadingChatEnd: `进行联系`,
  openChat: '聊天',
  // Links
  hcLink: 'https://support-hwa.nexters.com/hc/en-us',
  // Help Center
  popularTopics: '推广文章',
  search: '搜索',
  searchResults: '- 结果',
  showAll: '显示全部',
  error: '出现了问题。请稍后再试。',
}